var escape = require("../app/node_modules/css-loader/lib/url/escape.js");
exports = module.exports = require("../app/node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "@font-face{font-family:Lato;font-weight:400;font-style:normal;text-rendering:optimizeLegibility;src:url(" + escape(require("./node_modules/lato-font/fonts/lato-normal/lato-normal.woff2")) + ") format(\"woff2\"),url(" + escape(require("./node_modules/lato-font/fonts/lato-normal/lato-normal.woff")) + ") format(\"woff\")}@font-face{font-family:Lato Medium;font-weight:400;font-style:normal;text-rendering:optimizeLegibility;src:url(" + escape(require("./node_modules/lato-font/fonts/lato-medium/lato-medium.woff2")) + ") format(\"woff2\"),url(" + escape(require("./node_modules/lato-font/fonts/lato-medium/lato-medium.woff")) + ") format(\"woff\")}@font-face{font-family:Lato;font-weight:600;font-style:normal;text-rendering:optimizeLegibility;src:url(" + escape(require("./node_modules/lato-font/fonts/lato-bold/lato-bold.woff2")) + ") format(\"woff2\"),url(" + escape(require("./node_modules/lato-font/fonts/lato-bold/lato-bold.woff")) + ") format(\"woff\")}body{color:#fff}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader!../components/fonts.css
// module id = 218
// module chunks = 0